import React from 'react';
import { assertFunction } from '@Utils/assert';
import WithCombinedInfoComponent from './WithCombinedInfoComponent';

function withCombinedInfo({ loaded } = {}) {
  assertFunction(loaded, 'loaded');
  return function withCombinedInfoHOC(WrappedComponent) {
    function WithCombinedInfo(props) {
      return <WithCombinedInfoComponent loaded={loaded} WrappedComponent={WrappedComponent} {...props} />;
    }
    return WithCombinedInfo;
  };
}

export default withCombinedInfo;
